import React, { useState } from 'react';
import {
  Button, Divider, Input, message, Space, Table, Typography,
} from 'antd';
import { CheckOutlined, CloseOutlined, EditOutlined } from '@ant-design/icons';
import axios from 'axios';
import PropTypes from 'prop-types';
import ApplicationContainer from '../application-container';

const SettingsShow = ({ settings: initialSettings = [] }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [settings, setSettings] = useState(initialSettings);
  const [editingKey, setEditingKey] = useState(null);
  const [editingValue, setEditingValue] = useState('');

  const startEdit = (record) => {
    setEditingKey(record.key);
    setEditingValue(record.value ?? '');
  };

  const cancelEdit = () => {
    setEditingKey(null);
    setEditingValue('');
  };

  const saveEdit = (record) => {
    const csrf = document.head.querySelector("[name='csrf-token']").content;

    axios({
      headers: { 'X-CSRF-Token': csrf },
      method: 'patch',
      url: '/settings',
      data: { setting: { key: record.key, value: editingValue } },
    }).then(() => {
      setSettings((prev) => prev.map(
        (s) => (s.key === record.key ? { ...s, value: editingValue } : s),
      ));
      messageApi.success('Налаштування збережено');
      cancelEdit();
    }).catch((error) => {
      const errorMessage =
        error?.response?.data?.errors?.join('; ') || 'Помилка при збереженні';
      messageApi.error(errorMessage);
    });
  };

  const columns = [
    {
      title: 'Ключ',
      dataIndex: 'key',
      key: 'key',
      width: '35%',
      render: (text) => <Typography.Text code>{text}</Typography.Text>,
    },
    {
      title: 'Значення',
      dataIndex: 'value',
      key: 'value',
      render: (text, record) => {
        if (editingKey === record.key) {
          return (
            <Input
              value={editingValue}
              onChange={(e) => setEditingValue(e.target.value)}
              onPressEnter={() => saveEdit(record)}
              autoFocus
            />
          );
        }
        return <Typography.Text>{text}</Typography.Text>;
      },
    },
    {
      title: 'Дії',
      key: 'actions',
      width: 120,
      render: (_, record) => {
        if (editingKey === record.key) {
          return (
            <Space>
              <Button
                icon={<CheckOutlined />}
                size="small"
                type="primary"
                onClick={() => saveEdit(record)}
              />
              <Button
                icon={<CloseOutlined />}
                size="small"
                onClick={cancelEdit}
              />
            </Space>
          );
        }
        return (
          <Button
            icon={<EditOutlined />}
            size="small"
            onClick={() => startEdit(record)}
          />
        );
      },
    },
  ];

  return (
    <ApplicationContainer title="Налаштування">
      {contextHolder}
      <Divider>Сторінки</Divider>
      <Button href="/settings/telegram_updates">Повідомлення боту</Button>
      <Divider>Системні налаштування</Divider>
      <Table columns={columns} dataSource={settings} rowKey="key" pagination={false} />
    </ApplicationContainer>
  );
};

SettingsShow.propTypes = {
  settings: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    key: PropTypes.string.isRequired,
    value: PropTypes.string,
  })),
};

export default SettingsShow;
